import { motion, type Variants } from "framer-motion";
import type { ReactNode } from "react";

const variants: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: (delay: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay },
  }),
};

interface RevealProps {
  children: ReactNode;
  /** Animation start delay in seconds. */
  delay?: number;
  className?: string;
  /** Render as a different element tag. */
  as?: "div" | "section" | "li" | "span";
}

/** Fade-and-rise on scroll into view. Respects prefers-reduced-motion via Framer defaults. */
export function Reveal({ children, delay = 0, className, as = "div" }: RevealProps) {
  const MotionTag = motion[as];
  return (
    <MotionTag
      className={className}
      custom={delay}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
    >
      {children}
    </MotionTag>
  );
}
